import { Component, HostListener, OnInit, ViewChild, inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Enums } from 'src/app/Shared/enums';
import { Customer } from 'src/model/customer.model';
import { CustomerService } from 'src/services/customer.service';

@Component({
    selector: 'app-customer-lead-list',
    templateUrl: './customer-lead-list.component.html',
    styleUrls: ['./customer-lead-list.component.scss'],
    standalone: false
})
export class CustomerLeadListComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  protected enums = inject(Enums);
  private customerService = inject(CustomerService);

  leadProfileList: Customer[] = [];
  displayedColumns: string[];
  dataSource = new MatTableDataSource;

  innerWidth: any;
  showRemark: string;
  selectedStatus: number;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  routeSubscription: any;
  selectedCompany: number;

  ngOnInit(): void {
    this.routeSubscription = this.activatedRoute.paramMap.subscribe(params => {
      this.selectedCompany = (params.get('companyId') == undefined) ? undefined : +params.get('companyId');
    });

    // get customer
    this.getLeadsProfile();

    this.innerWidth = window.innerWidth;
    if (innerWidth <= 450)
      this.displayedColumns = ['DateCreated', 'Name', 'ICNumber', 'Occupation'];
    else
      this.displayedColumns = ['DateCreated', 'Name', 'ICNumber', 'Occupation', 'SalaryDay', 'Salary'];
  }

  //detect screen size
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = event.innerWidth;

    if (innerWidth <= 450)
      this.displayedColumns = ['DateCreated', 'Name', 'ICNumber', 'Occupation'];
    else
      this.displayedColumns = ['DateCreated', 'Name', 'ICNumber', 'Occupation', 'SalaryDay', 'Salary'];
  }

  goToCustomerProfile(selectedCustomerID: number, selectedProfileId: number) {
    this.router.navigate(['/manageCustomer', selectedCustomerID, selectedProfileId]);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;

    const processFilter = filterValue.replace(/-/g, '');
    this.dataSource.filter = processFilter;
  }

  async getLeadsProfile() {
    if (this.selectedCompany == undefined)
      this.leadProfileList = await this.customerService.getAllLeadsProfiles();
    else
      this.leadProfileList = await this.customerService.getCompanyLeadsProfiles(this.selectedCompany);

    this.dataSource = new MatTableDataSource<Customer>(this.leadProfileList);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}
